import React from 'react'
import PropTypes from 'prop-types'
import { Line, defaults, Chart } from 'react-chartjs-2'
import { Box } from '@material-ui/core'
import moment from 'moment'

import SOVColors from '../../constants/colors'
import ChartDateHighlighter from '../../classes/ChartDateHighlighter'

export class LineWrap extends React.Component {
  static propTypes = {
    sovNetworks: PropTypes.array,
    sovNetwork1: PropTypes.object,
    sovNetwork2: PropTypes.object,
    sovNetwork3: PropTypes.object,
    sovNetwork4: PropTypes.object,
    sovNetwork5: PropTypes.object,
    selectedDate: PropTypes.string,
    dateIndex: PropTypes.number,
    setDateIndex: PropTypes.func,
    dateArray: PropTypes.array
  }

  componentDidMount () {
    let that = this
    var originalLineDraw = Chart.controllers.line.prototype.draw;
    Chart.helpers.extend(Chart.controllers.line.prototype, {
      draw: function () {
        originalLineDraw.apply(this, arguments);
        var chart = this.chart;
        var ctx = chart.chart.ctx;
        ChartDateHighlighter.drawDateHighlihter(chart, ctx, that.props.dateArray)
      }
    })
  }

  render () {
    const { sovNetwork1, sovNetwork2, sovNetwork3, sovNetwork4, sovNetwork5 } = this.props
    defaults.fontFamily = 'Uni Sans Regular'
    let dataSet = []
    let data = {}
    const labels = sovNetwork1 && sovNetwork1.metrics.map(m => m.date)
    if (sovNetwork1 && sovNetwork1.metrics.length > 0) {
      const sovNetwork1Data = {
        label: sovNetwork1.label,
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: SOVColors.getSOVColors(sovNetwork1.label),
        borderColor: SOVColors.getSOVColors(sovNetwork1.label),
        pointBorderColor: SOVColors.getSOVColors(sovNetwork1.label),
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: SOVColors.getSOVColors(sovNetwork1.label),
        pointHoverBorderColor: SOVColors.getSOVColors(sovNetwork1.label),
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: sovNetwork1.metrics.map(m => Math.round(m.score * 100) / 100)
      }
      dataSet.push(sovNetwork1Data)
    }
    if (sovNetwork2 && sovNetwork2.metrics.length > 0) {
      const sovNetwork2Data = {
        label: sovNetwork2.label,
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: SOVColors.getSOVColors(sovNetwork2.label),
        borderColor: SOVColors.getSOVColors(sovNetwork2.label),
        pointBorderColor: SOVColors.getSOVColors(sovNetwork2.label),
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: SOVColors.getSOVColors(sovNetwork2.label),
        pointHoverBorderColor: SOVColors.getSOVColors(sovNetwork2.label),
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: sovNetwork2.metrics.map(m => Math.round(m.score * 100) / 100)
      }
      dataSet.push(sovNetwork2Data)
    }
    if (sovNetwork3 && sovNetwork3.metrics.length > 0) {
      const sovNetwork3Data = {
        label: sovNetwork3.label,
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: SOVColors.getSOVColors(sovNetwork3.label),
        borderColor: SOVColors.getSOVColors(sovNetwork3.label),
        pointBorderColor: SOVColors.getSOVColors(sovNetwork3.label),
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: SOVColors.getSOVColors(sovNetwork3.label),
        pointHoverBorderColor: SOVColors.getSOVColors(sovNetwork3.label),
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: sovNetwork3.metrics.map(m => Math.round(m.score * 100) / 100)
      }
      dataSet.push(sovNetwork3Data)
    }
    if (sovNetwork4 && sovNetwork4.metrics.length > 0) {
      const sovNetwork4Data = {
        label: sovNetwork4.label,
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: SOVColors.getSOVColors(sovNetwork4.label),
        borderColor: SOVColors.getSOVColors(sovNetwork4.label),
        pointBorderColor: SOVColors.getSOVColors(sovNetwork4.label),
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: SOVColors.getSOVColors(sovNetwork4.label),
        pointHoverBorderColor: SOVColors.getSOVColors(sovNetwork4.label),
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: sovNetwork4.metrics.map(m => Math.round(m.score * 100) / 100)
      }
      dataSet.push(sovNetwork4Data)
    }
    if (sovNetwork5 && sovNetwork5.metrics.length > 0) {
      const sovNetwork5Data = {
        label: sovNetwork5.label,
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: SOVColors.getSOVColors(sovNetwork5.label),
        borderColor: SOVColors.getSOVColors(sovNetwork5.label),
        pointBorderColor: SOVColors.getSOVColors(sovNetwork5.label),
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: SOVColors.getSOVColors(sovNetwork5.label),
        pointHoverBorderColor: SOVColors.getSOVColors(sovNetwork5.label),
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: sovNetwork5.metrics.map(m => Math.round(m.score * 100) / 100)
      }
      dataSet.push(sovNetwork5Data)
    }
    if (dataSet.length > 0) {
      data = {
        labels: labels,
        datasets: dataSet
      }
    }

    const options = {
      animation: false,
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: true,
            drawBorder: false
          },
          ticks: {
            display: true,
            fontSize: 12,
            fontColor: '#A7A9AC',
            callback: function (label) {
              return `${label}%`
            }
          }
        }],
        xAxes: [{
          ticks: {
            fontSize: 12,
            fontColor: '#A7A9AC',
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            callback: function (label) {
              return new Date(label).getDay() === 1 ? moment(label).format('MMM DD') : ''
            }
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      },
      lineAtIndex: this.props.dateIndex,
      selectedDate: this.props.selectedDate,
      onClick: (e, elements) => {
        if (elements && elements.length > 0) {
          this.props.setDateIndex(elements[0]._index)
        }
      }
    }
    if (dataSet.length === 0) {
      return null
    }
    return (
      <Box>
        <Line
          data={data}
          options={options} />
      </Box>
    )
  }
}

export default LineWrap